import Heading, { HeadingProps } from './Heading';

export type H3Props = Omit<HeadingProps, 'as' | 'level'>;

/**
 * A subsection heading: an `<h3>` at visual level 3.
 *
 * ## When to use
 *
 * - A subsection nested under an `H2`.
 *
 * ## When to choose another component
 *
 * - **Higher-level headings** — use `H1` or `H2`.
 * - **The smallest heading** — use `H4`.
 * - **Tag and visual level must differ** — use `Heading`, e.g.
 *   `<Heading as="h3" level={2}>`.
 * - **Body copy, captions, labels** — use `Text`.
 *
 * ## Composition rules
 *
 * Fixed to `as="h3" level={3}`. It exposes no `as`, `level`, `className` or
 * `style`, so its typography and semantics cannot be overridden.
 */
const H3 = (props: H3Props) => <Heading as="h3" level={3} {...props} />;

export default H3;
